import { render, staticRenderFns } from "./CoffInputTextEditor.vue?vue&type=template&id=6547f42d&scoped=true&"
import script from "./CoffInputTextEditor.vue?vue&type=script&lang=js&"
export * from "./CoffInputTextEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6547f42d",
  null
  
)

export default component.exports